import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin)

export default class PinnedNav {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    // find questions button
    this.button = document.getElementById('Questions')
  }

  init() {
    if (this.button !== null && typeof this.button !== 'undefined') {
      this.el.addEventListener('click', () => {
        gsap.to(window, { duration: 0.5, scrollTo: '#Questions' })
        this.button.click()
      })
    }
  }
}
